<template>

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'login-facebook',
  data: function () {
    return {

    }
  },
  mounted: function () {
    console.log('Facebook Login Redirect')
    console.log(this.$route.query.code)
    if (this.$route.query.code) {
      this.getFacebookLoginUser(this.$route.query.code)
        .then((response) => {
          this.getUserInfo()
            .then((response) => {
              this.getWeatherData(this.$store.state.user.profile.weather_region_id).then((response) => {
                this.$nextTick(function () {
                  this.$router.push('/')
                })
              })
            })
        })
    }
  },
  methods: {
    ...mapActions([
      'getFacebookLoginUser', 'getUserInfo', 'getWeatherData'
    ])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/FacebookLogin.vue